import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { Observable, Subscription } from 'rxjs';

import { UploadFileType } from '../../_models/models';
import { ListType } from '../upload-file/upload-file.component';

@Component({
  selector: 'app-upload-csv',
  templateUrl: './upload-csv.component.html',
  styleUrls: ['./upload-csv.component.less'],
})
export class UploadCsvComponent implements OnInit, OnDestroy {
  @Input() uploadText = 'Upload CSV';
  @Input() hideRemoveBtn = false;
  @Input() isLoading = false;
  @Input() hasError = false;
  @Input() uploadFileInstruction = 'Click or drag file to this area to upload';
  @Input() permittedFileTypes: UploadFileType[] = [
    UploadFileType.TEXT_CSV,
    UploadFileType.APPLICATION_CSV
  ];
  @Input() clearUpload$?: Observable<void>;

  @Output() fileUpload: EventEmitter<NzUploadFile> = new EventEmitter<NzUploadFile>();
  @Output() fileRemove: EventEmitter<void> = new EventEmitter<void>();

  uploadedFileName: string | null;
  listType: ListType = ListType.PICTURE_CARD;

  private clearSubscription?: Subscription;

  ngOnInit(): void {
    this.clearSubscription = this.clearUpload$?.subscribe(() => {
      this.clearUpload();
    });
  }

  ngOnDestroy(): void {
    this.clearSubscription?.unsubscribe();
  }

  handleChange(event: NzUploadFile): void {
    this.fileUpload.emit(event);
    this.uploadedFileName = event.file?.name;
  }


  removeFile(): void {
    this.fileRemove.emit();
    this.uploadedFileName = null;
  }

  private clearUpload(): void {
    this.uploadedFileName = null;
  }
}
